'use strict';
module.exports = function (str) {
	return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
		return '%' + c.charCodeAt(0).toString(16).toUpperCase();
	});
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/.npminstall/strict-uri-encode/1.1.0/strict-uri-encode/index.js
 ** module id = 656
 ** module chunks = 0
 **/